import React from 'react';
import css from './StatisticsSectionPackagesInfo.css';
import { FormattedMessage } from '../../util/reactIntl';
import { IconPenM, IconAnonymousL, IconBoost3xL, IconEyeHideL, SpaceshipIcon } from '../../icons';
import { Button } from '..';
import { ensureListing } from '../../util/data';
import classNames from 'classnames';

const ActionButton = ({ rootClassName, handlePackageActivation }) => (
    <Button
        type="button"
        className={classNames(css.addPackageButton, {
            [rootClassName]: !!rootClassName,
        })}
        onClick={handlePackageActivation}
    >
        Zusatzpaket hinzufügen
    </Button>
);

const StatisticsSectionNoPackages = ({
    isUserPackageType,
    handlePackageActivation,
    currentListing,
    renderActionButton = props => <ActionButton {...props} />,
}) => {
    const {
        attributes: {
            publicData: { extrapackagesData },
        },
    } = ensureListing(currentListing);

    const packagesNum = Object.values(extrapackagesData || {}).filter(s => !!s).length;
    const noData = packagesNum === 0;

    if (noData) {
        return (
            <>
                <p className={css.noData}>
                    <SpaceshipIcon />
                    <span>Keine Pakete aktiviert</span>
                </p>
                <aside>
                    <p>Verfügbare Pakete:</p>
                    <div className={css.advantages}>
                        <p>
                            <IconBoost3xL />
                            <span>Social Boost</span>
                        </p>
                        <p>
                            <IconEyeHideL />
                            <span>Privates {isUserPackageType ? 'Profil' : 'Profil'}</span>
                        </p>
                        <p>
                            <IconAnonymousL />
                            <span>Anonymes {isUserPackageType ? 'Profil' : 'Profil'}</span>
                        </p>
                    </div>
                </aside>
                {renderActionButton({
                    handlePackageActivation,
                    className: css.addPackageButton,
                })}
            </>
        );
    }

    return (
        <div className={css.packagesAvailable} onClick={handlePackageActivation}>
            <p>
                <SpaceshipIcon />
                <FormattedMessage
                    id={`SectionBoosting.activated-${packagesNum === 1 ? 'package' : 'packages'}`}
                    values={{ packagesNum }}
                />
                <IconPenM />
            </p>
        </div>
    );
};

StatisticsSectionNoPackages.Button = ActionButton;

export default StatisticsSectionNoPackages;
